module.exports = __webpack_public_path__ + "img/pdf.ca36def7.png";